<template>
  <StepTemplate :activeStepNr="this.activeStepNr"
                :myStepNr="this.myStepNr"
                :value="value"

  >
    <template slot="slide-form">

      <form data-vv-scope="xxx" @click.alt="testFillForm()">
        <!--============================================================================================================-->
        <!--
        <v-layout row>
            <v-flex xs11 class="mt-2"><h5>Angebot</h5></v-flex>
        </v-layout>
        -->
        <!--============================================================================================================-->
        <v-layout row class="section_header">
          <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Informations-Pflicht</h6></v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <v-flex xs10>
            Wir stellen ihnen nach §7VVG folgende erforderlichen Unterlagen zum Download zur Verfügung:
            <br>
            <br>
            <ul>
              <li>
                <i class="far fa-file-pdf" style="color:#cb0000;  font-size: 16px;"></i>&nbsp;
                <a target="_blank"
                   href="https://www.nordline-assecuranz.de/upload/download/pdf_allgemein/Verletzung_der_Anzeigepflicht_Paragraph19VVG.pdf">
                  Belehrung zur vorvertraglichen Anzeigepflicht nach §19 Abs.5 VVG</a>
              </li>
              <li>
                <i class="far fa-file-pdf" style="color:#cb0000;  font-size: 16px;"></i>&nbsp;
                <a target="_blank"
                   href="https://www.nordline-assecuranz.de/upload/download/pdf_allgemein/Belehrung_ueber_Widerrufsrecht.pdf">
                  Belehrung über das Widerrufsrecht</a>
              </li>
              <li>
                <i class="far fa-file-pdf" style="color:#cb0000;  font-size: 16px;"></i>&nbsp;
                <a target="_blank" href="https://www.nordline-assecuranz.de/upload/download/pdf_allgemein/datenverarbeitung.pdf">
                  das Merkblatt zur Datenverarbeitung</a>
              </li>
              <li v-if="'unfall'===rechnerName || 'seniorenunfall'===rechnerName ">
                <i class="far fa-file-pdf" style="color:#cb0000;  font-size: 16px;"></i>&nbsp;
                <a target="_blank"
                   href="https://www.nordline-assecuranz.de/upload/download/pdf_allgemein/see.pdf">
                  Schweigepflichtentbindungserklärung
                </a>

              </li>
              <li>
                <i class="far fa-file-pdf" style="color:#cb0000;  font-size: 16px;"></i>&nbsp;
                <a target="_blank" :href="pdf_path_bedingungen" style="letter-spacing: -0.03em;">
                  Produktinformationsblatt,&nbsp;Pflichtinformation,&nbsp;Versicherungsbedingungen
                </a>
              </li>
              <li v-for="(value, key, index) in pdf_pathes_zusaetze" type="hidden" :key="'field_'+index"
                  v-if="!(allSteps.Step_wohngebaude_II.fieldValues.woge_jn_heizung=='0')">
                <i class="far fa-file-pdf" style="color:#cb0000;  font-size: 16px;"></i>&nbsp;
                <a target="_blank" :href="'https://files.nordline-assecuranz.de/static/docs/bedingungen/'+value+'.pdf'">
                  {{ key }}
                </a>
              </li>


            </ul>
            <div>
              <br>
            </div>
            <div style="  font-size: 0.95rem;" v-html="label_abschluss_anerkannt">

            </div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <Rechner-hint-col>
            Für den Abschluss dieser Versicherung müssen die erforderlichen Vertragsunterlagen
            zur Kenntnis genommen und entsprechend für Ihre Unterlagen herunter geladen werden.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="Object.assign({}, fieldDefs.abschluss_anerkannt_pdfs,{label:' '})"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>

        </v-layout>
        <v-layout row>
          <div>
            <br>
            <br>
            <br>
          </div>
        </v-layout>
        <!--============================================================================================================-->
        <v-layout row class="section_header">
          <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>
            Einwilligungsklausel nach dem Bundesdatenschutzgesetz (DSGVO)</h6></v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <v-flex xs11 style="  font-size: 0.9rem;">
            <br>
            Ich willige ein, dass die Nordline Assecuranz AG im erforderlichen Umfang Daten,
            die sich aus den Antragsunterlagen oder der Vertragsdurchführung (Beiträge, Versicherungsfälle,
            Risiko-/Vertragsänderung) ergeben,
            an den für Sie zuständigen Versicherer und an den Rückversicherer zur Beurteilung des Risikos
            und zur Abwicklung der Rückversicherung sowie zur Beurteilung des Risikos und der Ansprüche an
            anderer Versicherer und/oder an den Gesamtverband der Deutschen Versicherungswirtschaft e.V.
            zur Weitergabe dieser Daten an andere Versicherer übermittelt.
            <br>
            <br>Diese Einwilligung gilt auch unabhängig vom Zustandekommen des Vertrages sowie für
            entsprechende Prüfungen bei anderweitig beantragten (Versicherungs-)Verträgen und bei künftigen
            Anträgen.
            <br>Ich willige ferner ein, dass die Nordline Assecuranz AG meine allgemeinen
            Antrags-, Vertrags- und Leistungsdaten in einer gemeinsamen Datensammlung führt und an die für
            mich zuständigen Vermittler weitergibt,
            soweit dies der ordnungsgemäßen Durchführung meiner Versicherungsangelegenheiten dient.
            <br>
            <br>Ferner ermächtige ich die Nordline Assecuranz AG bei allen Vorversicherern des
            im Antrag nachgefragten Zeitraums alle risikorelevanten Daten, insbesondere Anzahl und Höhe der
            Vorschäden nachzuprüfen.
            <br>
            <br>
          </v-flex>
        </v-layout>
        <v-layout row>
          <Rechner-hint-col>
            Hier bestätigen Sie, dass Sie über die Verarbeitung Ihrer Daten informiert wurden.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.abschluss_anerkannt_datenschutz"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>

        <!-- ...................................................................................................
        Wenn in der URL bereits eine Vermittler-Nr angegeben wurde, soll diese nicht überschrieben werden
        und daher muss auch nicht nach einer Nr (Vollmacht) gefragt werden
        Sollte jedoch keine Verm-Nr. in der URL sein kann hier das Verm.Nr. Feld aktiviert werden
        (wird es trotz fehlender Verm.Nr in der URL nicht aktiviert, so wird die Nr 18756 verwendet
        -->
        <v-layout row class="section_header" v-if="(visible_field_HV_NrVollmacht==true || visible_HauptVermNr==true)&&(1==1 || visible_field_UV_NrVollmacht==true)">
          <v-flex xs11 class="mt-2 blue-grey lighten-4 HauptVermittler"><h6>{{ header_HauptVermittler_label }}</h6></v-flex>
        </v-layout>
        <v-layout row v-if="visible_field_HV_NrVollmacht==true">
          <Rechner-hint-col>
            <div>
              <b><i>Vermittler/Makler:</i></b>
              <br>Sind Sie Vermittler bzw. haben eine Vermittler-Nr und eine Vermittler-Vollmacht, dann bestätigen Sie mit ja, um ihre Vermittler-Nr. anzugeben
            </div>

          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col title="Haupt-Vermittler-Vollmacht"
                               :fielddef="fieldDefs.abschluss_VermVollmacht_vorhanden"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>

        <!------------------------------------------------------------------------------------------------------------
        ist EINE  Verm. Nr vorhanden und der param  hv_mode != hidden, dann wird das Verm.Feld gezeigt, ABER disabled.
        ist KEINE Verm.Nr. vorhanden und der param  hv_mode != hidden, dann wird das Verm.Feld gezeigt, UND  enabled (ausser hv_mode == passive -> disabled)
        -->
        <v-layout row v-if="visible_HauptVermNr==true">
          <Rechner-hint-col>
            <div>
              <b><i>Vermittler/Makler</i></b>
              Geben Sie hier Ihre Vermittlernummer ein.
            </div>

          </Rechner-hint-col>
          <v-flex xs3>
            <Rechner-field-col title="Haupt-Vermittler"
                               :fielddef="fieldDefs.abschluss_Vermittler_nr" v-model="value.fieldValues"
                               :$v="$v" :disabled="disabled_HauptVermNr==true"></Rechner-field-col>
          </v-flex>
          <v-flex xs7>
            <Rechner-field-col title="Haupt-Vermittler eMail"
                               :fielddef="fieldDefs.abschluss_Vermittler_email" v-model="value.fieldValues"
                               :$v="$v" ></Rechner-field-col>   <!-- :disabled="true" -->
          </v-flex>

        </v-layout>

        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row class="section_header" v-if="visible_field_UV_NrVollmacht==true">
          <v-flex xs11 class="mt-2 blue-grey lighten-4 UnterVermittler"><h6>{{ header_UnterVermittler_label }}</h6></v-flex>
        </v-layout>
        <v-layout row v-if="visible_field_UV_NrVollmacht==true">
          <Rechner-hint-col>
            <div>
              <b><i>Vermittler/Makler:</i></b>
              <br>Sind Sie Vermittler bzw. haben eine Vermittler-Nr und eine Vermittler-Vollmacht, dann bestätigen Sie mit ja, um ihre Vermittler-Nr. anzugeben
            </div>

          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col title="Unter-Vermittler-Vollmacht"
                               :fielddef="fieldDefs.abschluss_UnterVermVollmacht_vorhanden"
                               v-model="value.fieldValues"
                               direction="row"
                               :disabled="!(value.fieldValues.abschluss_VermVollmacht_vorhanden>0)"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>

        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row v-if="visible_UnterVermNr==true">
          <Rechner-hint-col>
            <div>
              <b><i>Vermittler/Makler</i></b>
              Geben Sie hier Ihre Vermittlernummer ein.
            </div>

          </Rechner-hint-col>
          <v-flex xs3>
            <Rechner-field-col title="Unter-Vermittler"
                               :fielddef="fieldDefs.abschluss_UnterVermittler_nr" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs7>
            <Rechner-field-col title="Unter-Vermittler eMail"
                               :fielddef="fieldDefs.abschluss_UnterVermittler_email" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>

        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row class="section_header">
          <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Abschluss</h6></v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row v-if="visible_aditionalMail==true">
          <Rechner-hint-col>
            <div>
              xxxx
            </div>

          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col title="weitere sonstige eMail"
                               :fielddef="fieldDefs.abschluss_antrag_an_email" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>

        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Hier können sonstige Bemerkungen notiert werden, die für den Abschluss dieser Versicherung
            relevant sind.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.abschluss_bemerkungen" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>


        <!--============================================================================================================-->
        <!--
        <template
                v-if="$store.state.rechnerConfig.rechnerInfo.conf_kreditkarte==1 && $store.getters.subDomain !='rechner-intern' ">
            <v-layout row class="section_header">
                <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Kreditkarte</h6></v-flex>
            </v-layout>


            <v-layout row>
            </v-layout>
            <v-layout row>
                <v-flex xs6>
                    <img style="margin: 10px 0 -5% 17%; width:30%; position:relative;"
                         src="@/assets/test/images/kreditkarte_siegel.jpg">
                    <img style="margin: 0 0 -5% 8%; width:80%;" src="@/assets/test/images/kredit-karte.jpg">
                </v-flex>
                <v-flex xs5>
                    <div style="padding:0 0 0 10px;">
                        <h2 style="text-align:left">Jetzt sichern: Ihr&nbsp;Gratis&#8209;Geschenk</h2>
                        <br>
                        <h3 style="text-align:left">Schleswiger MasterCard Gold</h3>
                        <br>
                        <br>
                        <ul class="creditcard_list">
                            <li>dauerhaft gebührenfrei</li>
                            <li>bis zu 7 Wochen zinsfreies Zahlungsziel</li>
                            <li>sofortiger Verfügungsrahmen möglich</li>
                            <li>unkompliziertes Bargeld am Automaten</li>
                            <li>kostenlose Reiseversicherung inklusive</li>
                        </ul>
                        <br>
                        <div>
                            <v-icon medium class="primary--text" floating style="margin: 0 0 0 -6px">info
                            </v-icon>
                            weitere Informationen finden Sie <a target='_blank'
                                                                href="http://www.advanzia.com/vorteile">HIER</a>
                        </div>
                        <div style="padding:20px 0 0 10px;font-size: 0.85em;color:#768ea4;line-height: 1.2em;">
                            <a href="www.advanzia.com/agb">Die Allgemeinen Geschäftsbedingungen</a>, das
                            Widerrufsrecht sowie die SCHUFA und Datenschutz Klauseln habe ich verstanden und zur
                            Kenntnis genommen.
                            Die Schleswiger Mastercard GOLD wird von der Advanzia Bank S.A., 9, rue Gabriel
                            Lippmann, L-5365 Munsbach, herausgegeben.
                            Die Advanzia Bank S.A. ist somit Vertragspartnerin des Karteninhabers.
                            <br><br>
                        </div>
                    </div>
                </v-flex>
            </v-layout>





            <v-layout row>
                <Rechner-hint-col>
                    xxxx
                </Rechner-hint-col>
                <v-flex xs10>
                    <Rechner-field-col id="field_credcard_jn"
                                       :class="{[$vuetify.breakpoint.name+'_breakpoint']:true, field_credcard_jn:true}"
                                       :fielddef="fieldDefs.credcard_jn"
                                       v-model="value.fieldValues"
                                       direction="col"
                                       :$v="$v"
                    ></Rechner-field-col>
                </v-flex>
            </v-layout>





            <template v-if="value.fieldValues.credcard_jn == 1">
                <v-layout row style="margin: -20px 0 0 0;">
                    <Rechner-hint-col>
                        xxxxx2
                    </Rechner-hint-col>
                    <v-flex xs5>
                        <Rechner-field-col
                                :fielddef="fieldDefs.credcard_geburtsort"
                                v-model="value.fieldValues"
                                direction="row"
                                :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                    <v-flex xs5>
                        <Rechner-field-col
                                :fielddef="fieldDefs.credcard_nation"
                                v-model="value.fieldValues"
                                direction="row"
                                :autocomplete="true"
                                :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>
            </template>


        </template>
          -->
        <v-layout row>
          <div>
            <br>
            <br>
            <br>
          </div>
        </v-layout>
        <!--============================================================================================================-->

        <v-layout row>
          <v-flex xs11 class="">
            <br>
            Sie können sich nun unser Angebot ansehen und herunterladen ...
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12 class="">
            <form ref="formAngebot" method="post"
                  :action="$store.state.session.api_url.replace('api-request','angebot.pdf')"
                  target="_blank" accept-charset="UTF-8">
              <input type="hidden" name='command' value="get_AngebotPDF">
              <input type="hidden" name='args[url_param_rechner]' :value="$route.params.rechnerName">
              <input type="hidden" name='args[url_param_tariffilter]' :value="$route.query.tariffilter">
              <input type="hidden" name='args[url_param_tarifgruppe]' :value="$route.query.tarifgruppe">
              <input type="hidden" name='args[url_param_hauptverm_mode]' :value="param_hv_mode">
              <input type="hidden" name='args[url_param_unterverm_mode]' :value="param_uvr_mode">
              <input type="hidden" name='args[url_param_hauptverm_label]' :value="fieldDefs.abschluss_Vermittler_nr.label">
              <input type="hidden" name='args[url_param_unterverm_label]' :value="fieldDefs.abschluss_UnterVermittler_nr.label">
              <input type="hidden" name='args[mode]' value="Angebot">
              <input type="hidden" name='docType' :value="docType">
              <input type="hidden" name='referrer' :value="referrer">


              <input v-for="(value, key, index) in getAllFormValues()" type="hidden" :key="'field_'+index"
                     :name="'args[values]['+key+']'" :value="value">

              <template v-for="tarif in $store.state.tarife">
                                <span :key="'tarif_'+tarif.tarif_id">
                                <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][tarif_id]'"
                                       :value="tarif.tarif_id">
                                <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][tarif_name]'"
                                       :value="tarif.tarif_name">
                                <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][tarif_subName]'"
                                       :value="tarif.tarif_subName">
                                     <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][tarif_gruppe]'"
                                            :value="tarif.tarifgruppe">
                                <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][price_brutto_year]'"
                                       :value="tarif.price_brutto_year">
                                <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][price_brutto_zahlweise]'"
                                       :value="tarif.price_brutto_zahlweise">
                                <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][rabatt_prozent]'"
                                       :value="tarif.rabatt_prozent">
                                </span>
                <template v-for="(person, key, index) in tarif.personen">
                                <span :key="'tarif_'+tarif.tarif_id+'_person_'+(index+1)">
                                <input type="hidden" :name="'args[tarife]['+tarif.tarif_id+'][personen]['+(index+1)+'][price_brutto_zahlweise]'"
                                       :value="person.price_brutto_zahlweise">

                                </span>
                </template>
              </template>
              <v-btn type_XXX="submit"
                     color="primary"
                     class="white--text"
                     @click.native="submitForm_Angebot()"
                     :disabled="$v.value.fieldValues.$error" style="margin-left:0%;width:91%">
                Angebot nur anzeigen / drucken
              </v-btn>
            </form>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <template v-if="!($route.query.tarifgruppe=='i' && $store.getters.subDomain =='rechner-intern')">
          <v-layout row>
            <v-flex xs12 class="">
              <br>
              ...oder das Angebot jetzt als verbindlichen Antrag abschliessen ...
              <br>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 class="">
              <v-btn color="primary"
                     @click.native="submitForm_Abschluss()"
                     class="white--text"
                     :disabled="$v.value.fieldValues.$error" style=" margin-left:0%; width:91%">
                Vertrag jetzt abschließen
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
      </form>

      <!--============================================================================================================-->
      <!--============================================================================================================-->

      <template>
        <v-layout row justify-center>
          <v-dialog v-model="showWaitingSpinner" persistent>
            <v-card style="overflow: hidden;">
              <v-card-text style="position: relative">
                <div>
                  Ihr Antrag wird übermittelt ...
                  <input @keyup.alt.88="showWaitingSpinner=false" value="" ref="focusDummy"
                         style="position: absolute;top:1px;left: 1px;width: 100%;height: 100%;opacity: 0.001;cursor: pointer">
                </div>
                <v-progress-circular
                    indeterminate
                    v-bind:size="50"
                    class="primary--text"
                />
                <div>
                  Bitte warten!
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>


        </v-layout>
      </template>

      <!--============================================================================================================-->
      <!--============================================================================================================-->
      <template>
        <v-layout row justify-center>
          <v-dialog v-model="showErrorInfo" persistent>
            <v-card style="overflow: hidden;">
              <v-card-text style="position: relative; text-align: center">
                <div>
                  <br>
                  <br>
                  Die Übermittlung Ihrer Daten ist leider fehlgeschlagen!
                  <br>
                  <br>
                </div>
                <v-btn style="" @click.native="showErrorInfo=false">
                  weiter
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
      <!--============================================================================================================-->
      <!--============================================================================================================-->
    </template>
  </StepTemplate>

</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
import slideMixin from '../stepMixin'
import _ from 'lodash'
//import form_kreditkarte from '../common/form_kreditkarte'

//import {mapState} from 'vuex'

export default {
  //========================================================================================================
  data: function () {

    //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
    //an dieser Stelle können diese Werte überschrieben werden.
    // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
    var fieldDefs_OVERRIDE = {}

    return {
      baseUrl: process.env.BASE_URL,
      location: window.location,
      submit_command: '',
      docType: 'pdf',
      fieldDefs: fieldDefs_OVERRIDE,
      showWaitingSpinner: false,
      showErrorInfo: false,
      showFormKreditkarte: true,

    }
  }, //========================================================================================================
  name: 'Step_Abschluss',
  label: 'Angebot / Abschluss',
  label2: 'Angebot<br>Abschluss',
  fieldKeys: [
    'abschluss_anerkannt_pdfs',
    'abschluss_anerkannt_datenschutz',
    'abschluss_bemerkungen',
    'abschluss_VermVollmacht_vorhanden',
    'abschluss_UnterVermVollmacht_vorhanden',
    'abschluss_Vermittler_nr',
    'abschluss_Vermittler_email',
    'abschluss_UnterVermittler_nr',
    'abschluss_UnterVermittler_email',
    'abschluss_antrag_an_email',
    /*
     'credcard_jn',
     'credcard_geburtsort',
     'credcard_nation',
    */
  ],
  //========================================================================================================
  mixins: [slideMixin],
  computed: {
    //..................................................................................................
    rechnerName: function () {
      return this.$store.state.rechnerConfig.rechnerInfo.name
    }, //..................................................................................................
    label_abschluss_anerkannt: function () {
      var label = this.fieldDefs.abschluss_anerkannt_pdfs.label
      if ('unfall' === this.rechnerName || 'seniorenunfall' === this.rechnerName) {
        label = label.replace('[Schweigefplicht-Platzhalter]', 'die Schweigepflichtentbindungserklärung,')
      } else {
        label = label.replace('[Schweigefplicht-Platzhalter]', '')
      }
      return label
    },//..................................................................................................


    pdf_path_bedingungen: function () {
      var tarife = this.$store.state.tarife
      var tid = this.allSteps.Step_Tarifwahl.fieldValues.vertrag_tarifwahl
      var tarif = _.find(tarife, {'tarif_id': tid})
      console.log('§ § § § § § § § § § § § § §')
      console.log(tarife, tid, tarif)
      if (tarif) {
        var fileName = tarif.pdfs
        var filePathAndName = 'https://files.nordline-assecuranz.de/static/docs/bedingungen/' + fileName + '.pdf'
      } else {
        filePathAndName = '[noch nicht möglich]'
      }
      return filePathAndName
    }, //..................................................................................................
    pdf_pathes_zusaetze: function () {
      var tarife = this.$store.state.tarife
      var tid = this.allSteps.Step_Tarifwahl.fieldValues.vertrag_tarifwahl
      var tarif = _.find(tarife, {'tarif_id': tid})
      if (tarif) {
        return tarif.pdfs_zusaetze
      } else {
        return []
      }
    }, //..................................................................................................
    referrer: function () {
      var referrer = window.document.referrer
      var a = document.createElement('a')
      a.href = referrer
      var referrer_doamin = a.hostname
      console.log('referrer', referrer_doamin)
      return referrer_doamin
    }, //..................................................................................................
    /*
    Label von Haupt- / Unter-Vermittler
    ---------------------------------------
    ...wird in Rechner_Page.beforeCreate festgelegt, wenn 'success' im AJAX 'getRechnerConfig' ausgeführt wird.
    Dort werden dann anhand der URL-Paramter/Situation die Labels bestimmt

    visible / hidden
    ------------------------
Verm-Nr-Vollmacht   1vx	(param_VNr ==null && param_hvMode!=hidden)                       			else	1hx
VermittlerNr	    2vx	(field_VNrVollmacht  ==true  ||  param_VNr!=null ) && param_hv != hidden    else	2hx
Verm.Mail	        3vx	(field_VNrVollmacht  ==true  ||  param_VNr!=null ) && param_hv != hidden    else	3hx

UnterV-Nr-Vollmacht 7vx	(param_UVNr==null && param_uvMode!=hidden)                      			else	7hx
Unter-Verm.Nr	    4vx	(field_UVNrVollmacht ==true  ||  param_UVNr!=null ) && param_uv != hidden   else	4hx
UnterVerm.Mail	    5vx	(field_UVNrVollmacht ==true  ||  param_UVNr!=null ) && param_uv != hidden   else	5hx

weitere Mail	    6vx	 field_VNrVollmacht !=true  && param_uv != active					        else	6hx

    disabled / enabled:
    --------------------
Verm-Nr-Vollmacht	1vd	NEVER			    else	1xe
VermittlerNr	    2vd	 param_VNr!=null    else	2xe
Verm.Mail	        3vd	ALWAYS				else	3xe

UnterV-Nr-Vollmacht	7vd	NEVER			    else	7xe
Unter-Verm.Nr	    4vd	param_UVNr!=null	else	4xe
Antrag an Mail	    5vd	NEVER				else	5xe

weitere Mail	    6vd	NEVER				else	6xe
    //..................................................................................................
    */
    param_hv_mode: function () {
      // alte Version: var hv_mode = this.$route.query.hv_mode
      var hv_mode = this.$store.state.rechnerConfig.vermittlerData.HVM
      if (this.$route.params.vermittlerNr > 0) {
        var result = (typeof hv_mode === "undefined" || hv_mode === "" ? 'passive' : hv_mode)
      } else {
        var result = (typeof hv_mode === "undefined" || hv_mode === "" ? 'active' : hv_mode)
      }
      return result
    }, //..................................................................................................
    param_uvr_mode: function () {
      // alte Version: var uvr_mode = this.$route.query.uvr_mode
      var uvr_mode = this.$store.state.rechnerConfig.vermittlerData.UVM
      let result = (typeof uvr_mode === "undefined" || uvr_mode === "" ? 'hidden' : uvr_mode)
      return result
    }, //..................................................................................................
    param_HauptVermNr: function () {
      let VermNr = this.$route.params.vermittlerNr
      let result = (typeof VermNr === "undefined" || VermNr === "" ? 0 : VermNr)
      return result
    }, //..................................................................................................
    param_UnterVermNr: function () {
      let UnterVermNr = this.$route.params.unterVermittlerNr
      let result = (typeof UnterVermNr === "undefined" || UnterVermNr === "" ? 0 : UnterVermNr)
      return result
    }, //..................................................................................................
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    visible_field_HV_NrVollmacht: function () {
      let result = (this.param_HauptVermNr == 0 && this.param_hv_mode != "hidden") ? true : false
      return result
    }, //..................................................................................................
    visible_HauptVermNr: function () {
      let fieldValue_HVNr_Vollm_vorhanden = this.value.fieldValues.abschluss_VermVollmacht_vorhanden
      let result = ((fieldValue_HVNr_Vollm_vorhanden > 0 || this.param_HauptVermNr > 0) && this.param_hv_mode != 'hidden') ? true : false
      return result
    }, //..................................................................................................
    visible_HauptVermMail: function () {
      return this.visible_HauptVermNr
    }, //..................................................................................................
    disabled_HauptVermNr: function () {
      let result = (this.param_HauptVermNr > 0) ? true : false
      return result
    }, //..................................................................................................
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    visible_field_UV_NrVollmacht: function () {
      let result = (this.param_UnterVermNr == 0 && this.param_uvr_mode != "hidden") ? true : false
      return result
    }, //..................................................................................................
    visible_UnterVermNr: function () {
      let fieldValue_UVNr_Vollm_vorhanden = this.value.fieldValues.abschluss_UnterVermVollmacht_vorhanden
      let result = (fieldValue_UVNr_Vollm_vorhanden == 1 || this.param_uvr_mode > 0 && this.param_hv_mode != 'hidden') ? true : false
      return result
    }, //..................................................................................................
    visible_UnterVermMail: function () {
      return this.visible_UnterVermNr
    }, //..................................................................................................
    disabled_UnterVermNr: function () {
      let result = (this.param_UnterVermNr > 0) ? true : false
      return result
    }, //..................................................................................................
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    visible_aditionalMail: function () {
      let fieldValue_HVNr_Vollm_vorhanden = this.value.fieldValues.abschluss_VermVollmacht_vorhanden
      let fieldValue_UVNr_Vollm_vorhanden = this.value.fieldValues.abschluss_UnterVermVollmacht_vorhanden
      let result = (fieldValue_HVNr_Vollm_vorhanden > 0 && fieldValue_UVNr_Vollm_vorhanden > 0 && this.param_uvr_mode == 'active') ? false : true
      return result
    }, //..................................................................................................
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    header_HauptVermittler_label: function () {
      // alte Version:
      var uvr_mode = this.$store.state.rechnerConfig.vermittlerData.UVM
      let result = "Vermittler";
      if (uvr_mode > '') {
        result = "Haupt-Vermittler";
      }
      return result
    }, //..................................................................................................
    header_UnterVermittler_label: function () {
      // alte Version:
      var hv_mode = this.$store.state.rechnerConfig.vermittlerData.HVM
      let result = "Unter-Vermittler";
      if (hv_mode == 'hidden') {
        result = "Vermittler";
      }
      return result
    }, //..................................................................................................


  }
  , //______________________________________________________________________________________________________________________
  methods: {
    //——————————————————————————————————————————————————————————————————————————————
    getAllFormValues: function () {
      var values = {}
      for (var key in this.allSteps) {
        values = _.assign(values, this.allSteps[key].fieldValues)
      }
      return values
    }
    ,
    //——————————————————————————————————————————————————————————————————————————————
    submitForm_Angebot: function () {
      this.submit_command = 'get_AngebotPDF'
      this.$nextTick(function () {
        console.log('try to Submit formAngebot')
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$refs.formAngebot.submit()
        }
      })
    }
    , //——————————————————————————————————————————————————————————————————————————————
    submitForm_Abschluss: function () {
      this.submit_command = 'submit_Antrag'
      var tarife = {}
      _.forEach(this.$store.state.tarife, (item) => {
        tarife['' + item.tarif_id] = item
      })
      //-------------------------------------------------------------------------------
      //validate:
      console.log('BEFORE', this.$v.$invalid)
      this.$v.$touch()
      console.log('AFTER', this.$v.$invalid)
      //------------------------------------------------------------------------------
      if (!this.$v.$invalid) {
        //console.log("SUBMITTING TEST : ALL VERIFY OKAY", this.getAllFormValues(),);
        //return
        //...........................................................
        // waiting Modal:
        this.showWaitingSpinner = true
        // kleine Debugger-Hilfe um Modal zu schliessen:
        this.$nextTick(() =>
            this.$refs.focusDummy.focus()
        )
        //...........................................................
        this.$store.commit('set_rechnerStatus', {data: 'Antrag submit pending'})

        this.$store.dispatch(
            'sendApiRequest',
            {
              sender: 'RechnerTemplate->created',
              command: 'submit_Antrag',
              args: {
                url_param_rechner: this.$route.params.rechnerName,
                url_param_hauptverm_mode: this.param_hv_mode,
                url_param_unterverm_mode: this.param_uvr_mode,
                url_param_hauptverm_label: this.fieldDefs.abschluss_Vermittler_nr.label,
                url_param_unterverm_label: this.fieldDefs.abschluss_UnterVermittler_nr.label,
                values: this.getAllFormValues(),
                mode: 'Antrag',
                tarife: tarife,

              },
              onSuccess: (response) => {
                this.showWaitingSpinner = false
                this.$nextTick(() => {
                  console.log('Antrang submitted')
                  console.log(response.data)
                  if (response.data.status === 'success') {
                    console.log('submit sucessed')
                    this.$store.commit('set_rechnerStatus', {data: 'Antrag: submit successed'})
                  } else {
                    this.showErrorInfo = true
                    this.$store.commit('set_rechnerStatus', {data: 'Antrag: submit failed'})
                    console.log('submit NOT sucessed')
                  }
                })
              },
              onError: (response) => {
                this.showWaitingSpinner = false
                this.$store.commit('set_rechnerStatus', {data: 'Antrag: submit failed'})
                this.showErrorInfo = true

              },
            }
        )
      }

    }
    , //——————————————————————————————————————————————————————————————————————————————
    close_ErrorInfo: function () {
      this.showErrorInfo = false
      this.$store.commit('set_rechnerStatus', {data: 'inputing data'})
    }
    , //——————————————————————————————————————————————————————————————————————————————
    update_VermMail_by_VermNr: function () {
      let vermittlerNr = this.value.fieldValues.abschluss_Vermittler_nr
      if (1==1 && vermittlerNr > 999) {

        this.$store.dispatch(
            'sendApiRequest',
            {
              method: 'get',
              sender: 'RechnerTemplate->created',
              command: 'get_vermittler_maskedMail',
              args: {
                url_param_rechner: this.$route.params.rechnerName,
                url_param_unterverm_mode: this.param_uvr_mode,
                values: {'vermittlerNr': vermittlerNr},

              },
              onSuccess: (response) => {
                this.$nextTick(() => {
                  console.log('get_vermittler_maskedMail submitted')
                  console.log(response.data)
                  if (response.data.status === 'success') {
                    console.log('submit sucessed')
                    this.value.fieldValues.abschluss_Vermittler_email = response.data.vermittler_maskedMail
                  } else {
                    //  this.showErrorInfo = true
                    this.$store.commit('set_rechnerStatus', {data: 'get_vermittler_maskedMail: submit failed'})
                    console.log('submit NOT sucessed')
                  }
                })
              },
              onError: (response) => {
                //      this.showWaitingSpinner = false
                //      this.$store.commit('set_rechnerStatus', {data: 'get_vermittler_maskedMail: submit failed'})
                //     this.showErrorInfo = true
                console.log('submit ERROR')
              },
            }
        )
      } else {
       //  this.value.fieldValues.abschluss_Vermittler_email = "{keine Mail gefunden}"
      }
    }
    , //——————————————————————————————————————————————————————————————————————————————

  }
  , //===========================================================================================================
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
        console.log('WATCHER fieldValues in ', this.$options.label)
        var fV = this.value.fieldValues
        var fVold = this.frmValuesOld
        var earlyExit = true
        for (var key in fV) {
          if (fV[key] !== fVold[key]) {
            earlyExit = false
            console.log('changed ', key, fVold[key], '->', fV[key])
            this.update_Ort_by_PLZ(key)

          }
        }
        if (earlyExit === true) {
          console.log('NO changes -> early EXIT')
          return
        }
        /*------------------------------------------------------------------------------------*/
        if (fV.abschluss_Vermittler_nr !== fVold.abschluss_Vermittler_nr) {
          this.update_VermMail_by_VermNr()
          console.log('WATCHER: update  VerMail per request...')
        }
        /*------------------------------------------------------------------------------------
        Wenn in der URL bereits eine Vermittler-Nr angegeben wurde, soll diese nich tüberschrieben werden
        und daher muss auch nicht nach einer Nr (Vollmacht) gefragt werden
        Sollte jedoch keine Verm-Nr. in der URL sein kann hier das Verm.Nr. Feld aktiviert werden
        (wird es trotz fehlender Verm.Nr in der URL nicht aktiviert, so wird die Nr 18756 verwendet
        */
        if (fV.abschluss_VermVollmacht_vorhanden === '1' && fV.abschluss_VermVollmacht_vorhanden !== fVold.abschluss_VermVollmacht_vorhanden) {
          this.value.fieldValues.abschluss_Vermittler_nr = null
          this.value.fieldValues.abschluss_Vermittler_email = null
          this.value.fieldValues.abschluss_UnterVermittler_nr = null
          this.value.fieldValues.abschluss_UnterVermVollmacht_vorhanden = 2
          console.log('WATCHER: update  Vollmacht_vorhanden:  ON -> set Vermittler_nr to NULL')
        }
        if (fV.abschluss_VermVollmacht_vorhanden === '0' && fV.abschluss_VermVollmacht_vorhanden !== fVold.abschluss_VermVollmacht_vorhanden) {
          this.value.fieldValues.abschluss_Vermittler_nr = 18756
          this.value.fieldValues.abschluss_UnterVermittler_nr = 'OFF'
          this.value.fieldValues.abschluss_UnterVermVollmacht_vorhanden = 'OFF'
          console.log('WATCHER: update  Vollmacht_vorhanden: OFF -> set Vermittler_nr to 18756')
        }
        /*------------------------------------------------------------------------------------
       Unter-Vermittler-Nummer
       */

        if (fV.abschluss_UnterVermVollmacht_vorhanden === '1' && fV.abschluss_UnterVermVollmacht_vorhanden !== fVold.abschluss_UnterVermVollmacht_vorhanden) {
          this.value.fieldValues.abschluss_UnterVermittler_nr = null
          this.value.fieldValues.abschluss_UnterVermittler_email = null
          this.value.fieldValues.abschluss_antrag_an_email = null
          console.log('WATCHER: update  Vollmacht_vorhanden:  ON -> set Vermittler_nr to NULL')
        }
        if (fV.abschluss_UnterVermVollmacht_vorhanden === '0' && fV.abschluss_UnterVermVollmacht_vorhanden !== fVold.abschluss_UnterVermVollmacht_vorhanden) {
          this.value.fieldValues.abschluss_UnterVermittler_nr = 'OFF'
          this.value.fieldValues.abschluss_UnterVermittler_email = null
          this.value.fieldValues.abschluss_antrag_an_email = null
          console.log("WATCHER: update  Vollmacht_vorhanden: OFF -> set UnterVermittler_nr to 'OFF")
        }
        /*------------------------------------------------------------------------------------*/
        /*
        if (fV.credcard_jn === '0' && fV.credcard_jn !== fVold.credcard_jn) {
            this.value.fieldValues.credcard_geburtsort = '-/-'
            this.value.fieldValues.credcard_nation = '-/-'
            console.log('WATCHER: update  Kreditkarte: credcard_jn OFF -> set all to -/-')
        }
        if (fV.credcard_jn === '1' && fV.credcard_jn !== fVold.credcard_jn) {
            this.value.fieldValues.credcard_geburtsort = null
            this.value.fieldValues.credcard_nation = null
            console.log('WATCHER: update  Kreditkarte: credcard_jn ON -> set all to NULL')
        }
        */
        /*------------------------------------------------------------------------------------*/
        this.frmValuesOld = _.assign({}, fV)
      }
      ,
      deep: true,

    }
    ,
  }
  , //===============================================================================================

  components: {
    /* programmatically setted by step-mixin*/
  }
  , //===========================================================================================================
  props: [/* programmatically setted by step-mixin*/],
  //===========================================================================================================
  // HOOKS:
  /* programmatically setted by step-mixin*/
  created: function () {
    if (this.$route.query.tarifgruppe === 'i' && this.$store.getters.subDomain === 'rechner-intern') {
      this.value.fieldValues['abschluss_antrag_an_email'] = 'ohne@mail.de'
    }

    //Wenn in der URL bereits eine Vermittler-Nr angegeben wurde, soll diese nicht überschrieben werden
    //...und daher muss auch nicht nach einer Nr (Vollmacht) gefragt werden
    if (this.$route.params.vermittlerNr > '') {
      // '2' steht für: autom. Verm.Nr aus der URL
      this.value.fieldValues.abschluss_VermVollmacht_vorhanden = 2
    }
    if (this.visible_field_UV_NrVollmacht == false) {

      this.value.fieldValues.abschluss_UnterVermVollmacht_vorhanden = 2
    }

  },
  //===========================================================================================================
  mountes: function () {

  },
  //===========================================================================================================
}
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>


ul.creditcard_list {
  list-style-type: none;
  padding: 0;
}

ul.creditcard_list li {
  padding: 0px 0px 0px 26px;
  list-style: none;
  background-image: url(/static/images/check.gif);
  background-repeat: no-repeat;
  background-position: left 2px;
  background-size: 16px;
  line-height: 1.2em;
  margin: 0 0 10px 0px;
}

.field_credcard_jn.v-input {
  margin-top: 10px;
}

.field_credcard_jn .v-input__slot {
  margin-bottom: 4px;
}

.field_credcard_jn.xs_breakpoint .v-input__slot {
  min-height: 60px;
}

.field_credcard_jn .my_radio_input label {
  vertical-align: middle;
  justify-content: center;
  padding: 5px 6px 5px 6px;
  color: white;
  background-color: #669eff;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  max-width: 92%;
  min-width: 92%;
}

.field_credcard_jn .my_radio_input.accent--text label {
  color: #e4e4e4;
  background-color: #2f68a5;
}

.field_credcard_jn .my_radio_input label {
  color: #d5d5d5;
  background-color: #3a6696;
}

.field_credcard_jn .my_radio_input.accent--text:first-child label {
  color: white;
  background-color: #0478d8;
}

.field_credcard_jn .my_radio_input:first-child label {
  color: #eaeaea;
  background-color: #2f68a5;
}

.field_credcard_jn.xs_breakpoint .input-group__input label {
  min-height: 60px;
}

.btn:not(.btn--depressed) {
  box-shadow: -6px -6px 5px -5px rgba(50, 50, 50, 0.4) inset, 6px 6px 5px -3px rgba(250, 250, 250, 0.5) inset, 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}


</style>
